import axios from 'axios';
import Cookies from 'js-cookie';
import { create } from 'zustand';

import { SCCLIENT, SCCLIENTID } from './authStore';

/**
 * @typedef {Object} UserStore
 * @property {Object} user
 * @property {Function} verifyUser
 * @property {Function} updatedUser
 */

/**
 * User Store
 *
 * @returns {UserStore}
 */
export const useUserStore = create((set, get) => ({
	user: undefined,
	/**
	 * Verify user with existing token and userId
	 */
	verifyUser: async () => {
		const token = Cookies.get(SCCLIENT);
		const userId = Cookies.get(SCCLIENTID);
		const user = get().user;
		if (token && userId && !user) {
			try {
				axios.defaults.headers.common['Authorization'] = token;
				const { data: userData } = await axios.get(`/coords/${userId}`, {
					params: {
						filter: JSON.stringify({
							include: [
								{
									relation: 'coord_agency',
									scope: { include: [{ relation: 'hubs' }] },
								},
							],
						}),
					},
				});
				// const { data: agreements } = await axios.get(
				// 	`/coords/${userId}/agreements_unsigned`,
				// );
				// set(() => ({
				// 	user: { ...userData, unsignedAgreements: agreements.agreements },
				// }));
				set({ user: userData });
			} catch (err) {
				// fall through, old token, etc.
				set(() => ({ user: undefined }));
				delete axios.defaults.headers.common['Authorization'];
			}
		}
	},
	clearAgreements: () => {
		const { user } = get();
		delete user.unsignedAgreements;
		set({ user });
	},
	/**
	 * Update user in the store
	 * @param {Object} updatedUser
	 */
	updateUser: (updatedUser) => {
		set({ user: updatedUser });
	},
}));
